// BE action / blocking-reason slug → operator-friendly copy for the
// Treasury Ledger Payout v1 CRM. Pure string maps, no behavior. Kept
// separate from the presentational components so the component module
// only exports components (react-refresh friendly).

const NEXT_ACTION_LABEL: Record<string, string> = {
  request_approval: "Awaiting owner approval",
  record_tx: "Record treasury transfer",
  verify: "Awaiting on-chain verify",
  review: "Review failed payout",
  awaiting_request: "Waiting for partner withdrawal request",
  fix_destination_or_cancel: "Blocked — missing destination wallet",
  none: "No action needed",
};

export function nextActionLabel(action: string): string {
  return NEXT_ACTION_LABEL[action] ?? action;
}

// FE display-status refinement. The BE reports a partner with a payable
// BALANCE but NO actionable request as `ready` (+ nextAction
// `awaiting_request`). "Ready to pay" there is misleading — there is nothing
// for the admin to do until the partner requests a withdrawal — so the CRM
// shows "Available" instead. Every other status passes through unchanged.
export type CrmDisplayStatus =
  | "ready"
  | "available"
  | "pending"
  | "paid"
  | "blocked"
  | "none";

export function displayPayableStatus(input: {
  status: string;
  nextAction: string;
}): CrmDisplayStatus {
  if (input.status === "ready" && input.nextAction === "awaiting_request") {
    return "available";
  }
  return input.status as CrmDisplayStatus;
}

const BLOCKING_REASON_LABEL: Record<string, string> = {
  not_an_approved_partner: "Not an approved partner",
  no_available_balance: "No available balance",
};

export function blockingReasonLabel(reason: string): string {
  return BLOCKING_REASON_LABEL[reason] ?? reason;
}
